app.controller("agentSettingController", [
	"$scope",
	"isTabsView",
	"patientId",
	"$mdDialog",
	"ELEVEN_LABS_AI_TOUR_1261",
	function ($scope, isTabsView, patientId, $mdDialog,ELEVEN_LABS_AI_TOUR_1261) {
		this.$onInit = function () {
			$scope.selectedTabIndex = 0;
			$scope.selectedPrompt = null;
			$scope.patientId = patientId;
			$scope.$mdDialog = $mdDialog;
			setTimeout(() => {
				setupOnboard();
			}, 500);
		};

		$scope.isTabsView = isTabsView;

		$scope.navigatePrompt = (prompt) => {
			$scope.selectedTabIndex = 1;
			$scope.selectedPrompt = prompt;
		};

		$scope.resetPrompt = () => {
			$scope.selectedPrompt = null;
		};

		function setupOnboard() {
			if(!ELEVEN_LABS_AI_TOUR_1261){
                return;
            }
			document.querySelectorAll(".md-tab").forEach((el, index) => {
				if (el.tagName !== "MD-TAB-ITEM") {
					return;
				}
				if (el.innerText === "AI AGENT") {
					el.setAttribute("data-title", "welcome");
					el.setAttribute("data-intro", "Create AI agent with prompt and knowledge");
					el.setAttribute("data-step", "3");
				} else if (el.innerText === "PROMPT MANAGEMENT") {
					el.setAttribute("data-title", "welcome");
					el.setAttribute("data-intro", "Add prompt first");
					el.setAttribute("data-step", "1");
				} else if (el.innerText === "KNOWLEDGE BASE MANAGEMENT") {
					el.setAttribute("data-title", "welcome");
					el.setAttribute("data-intro", "Add knowledge if you have");
					el.setAttribute("data-step", "2");
				}
			});
			introJs
				.tour()
				.setOptions({
					tooltipClass: "intro-customTooltip",
					dontShowAgain: true,
					showBullets: false
				})
				.start();
		}
	},
]);
